import React, {
  cloneElement,
  JSX,
  useCallback,
} from 'react';

import { useAtom } from 'jotai';

import { ModalConfigT } from '@consumer-frontend/nc-utils';

import { modalConfigAtom } from '../../store';

export type NcModalAnchorPropsT = Omit<ModalConfigT, 'show'> & {
  children: JSX.Element;
};

export const NcModalAnchor: React.FC<NcModalAnchorPropsT> = ({
  anchorOnClick,
  children,
  ...modalConfigProps
}) => {
  const [, setModalConfig] = useAtom(modalConfigAtom);

  const openModal = useCallback(
    (ev: React.MouseEvent) => {
      ev.preventDefault();
      anchorOnClick?.(ev);

      setModalConfig({
        ...modalConfigProps,
        show: true,
      });
    },
    [
      anchorOnClick,
      modalConfigProps,
      setModalConfig,
    ],
  );

  return cloneElement(children, { onClick: openModal });
};
